import LogoComponent from "../../components/Logo";
import React, { useCallback, useMemo, useState } from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "@/components/resume/redux/hooks";
import resumeSlice from "@/components/resume/redux/services/resumeSlice";
import debounce from "@/utils/debounce";
import moment from "moment";
import Title2 from "./Title"
import Revocation from "@/pages/ResumeDetail/component/Revocation";
import Recover from "@/pages/ResumeDetail/component/Recover";
import FlexStyled from "@/styled/FlexStyled";
import Back from "./component/Back";
import SaveComponent from "./component/SaveComponent";
import Menu from "./Menu";
import { Upload, message } from "antd";
import { modifyResume, uploadResume, uploadResumeAttachment } from "@/http/api";
import { getParam } from "../Mobile/utils";
import { v4 } from "uuid";
import resumeDataSlice from "@/components/resume/redux/services/resumeDataSlice";
import getResumePath from "@/common/resume/getResumePath";
import getNestedProperty from "@/utils/getNestedProperty";
import getFieldBySlot from "@/common/module/getFieldBySlot";
import useResumeDetailInstance from "./hooks/useResumeDetailInstance";
import User from "@/components/user";

const TitleBoxStyled = styled.div`
  position: relative;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  pointer-events: none;
  display: flex;
  align-items: center;
`
const TitleStyled = styled.div`
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  //line-height: 50px;
  opacity: 0.6;
  margin-right: 4px;
  cursor: pointer;
  pointer-events: auto;
  //user-select: none;
`
const TitleIconStyled = styled.div`
  cursor: pointer;
  pointer-events: auto;
`
const TitleInputStyled = styled.input`
  height: 24px;
  pointer-events: auto;
  padding: 0 0.5em;
  outline: none;
  font-size: 14px;
  text-align: left;
  background-color: #fff;
  border: 1px solid #11BBA6;
  width: 230px;
`

const ButtonStyled = styled.div`
  width: 96px;
  height: 30px;
  background: #11BBA6;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;


  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  cursor: pointer;
`

const Button2Styled = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 104px;
    height: 30px;
    border-radius: 4px;
    border: 1px solid #00BCA6;
    background-color: #ffffff;
    font-size: 14px;

    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #11BBA6;
    cursor: pointer;
    &:hover {
        opacity: 0.8;
    }
`

const icon = <div style={{ width: 20, height: 20, position: "relative" }} dangerouslySetInnerHTML={{
    __html: `<svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="position: absolute;top: 0">
    <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="简历编辑页" transform="translate(-1836.000000, -15.000000)" fill="#FFFFFF" fill-rule="nonzero">
            <g id="编组-6备份" transform="translate(1814.000000, 10.000000)">
                <g id="加协作团队备份-11" transform="translate(22.000000, 5.000000)">
                    <g id="xiazai-15" transform="translate(3.500000, 3.000000)">
                        <path d="M12.3400236,12.6622222 L0.659976387,12.6622222 C0.291617473,12.6622222 0,12.9577778 0,13.3311111 C0,13.7044444 0.291617473,14 0.659976387,14 L12.3400236,14 C12.7083825,14 13,13.7044444 13,13.3311111 C13,12.9733333 12.7083825,12.6622222 12.3400236,12.6622222 Z M6.06257379,11.5111111 C6.18536009,11.6355556 6.35419126,11.6977778 6.50767414,11.6822222 C6.66115702,11.6822222 6.82998819,11.6355556 6.9527745,11.5111111 L10.9433294,7.46666667 C11.1735537,7.23333333 11.1735537,6.84444444 10.9433294,6.61111111 C10.7131051,6.37777778 10.3293979,6.37777778 10.0991736,6.61111111 L7.0755608,9.67555556 L7.0755608,0.606666667 C7.0755608,0.28 6.81463991,0 6.47697757,0 C6.13931523,0 5.87839433,0.264444444 5.87839433,0.606666667 L5.87839433,9.61333333 L2.91617473,6.61111111 C2.68595041,6.37777778 2.30224321,6.37777778 2.07201889,6.61111111 C1.84179457,6.84444444 1.84179457,7.23333333 2.07201889,7.46666667 L6.06257379,11.5111111 Z" id="形状"></path>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>`
}} />
const icon2 = <div dangerouslySetInnerHTML={{
    __html: `<svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="简历详情编辑页" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.602698038">
        <g id="简历编辑页备份-4" transform="translate(-706.000000, -18.000000)" fill="#FFFFFF">
            <g id="文本备份-19" transform="translate(706.000000, 17.475000)">
                <rect id="矩形" fill-opacity="0" x="0" y="0.525" width="14" height="14"></rect>
                <g id="自动搜索备份-3" fill-rule="nonzero">
                    <g id="bianji-2" transform="translate(0.702692, 1.752713)">
                        <path d="M12.7588461,10.5162791 L6.10615384,10.5162791 C5.83692307,10.5162791 5.62153846,10.7362274 5.62153846,11.0111628 C5.62153846,11.2860982 5.83692307,11.5060465 6.10615384,11.5060465 L12.8126923,11.5060465 C13.0819231,11.5060465 13.2973077,11.2860982 13.2973077,11.0111628 C13.2434615,10.7912145 13.0280769,10.5162791 12.7588461,10.5162791 Z M0.484615384,11.5472868 L2.79999999,11.5472868 C2.90769231,11.5472868 3.06923077,11.4922997 3.12307692,11.3823256 L11.0923077,3.24423773 C11.3076923,3.02428941 11.3076923,2.74935401 11.0923077,2.52940569 L8.83076922,0.164961236 C8.61538461,-0.0549870788 8.34615383,-0.0549870788 8.13076922,0.164961236 L6.51538461,1.81457364 L0.161538461,8.30304911 C0.0538461486,8.41302327 0,8.52299742 0,8.63297159 L0,10.997416 C0,11.1073902 0.0538461486,11.2723514 0.161538461,11.3823256 C0.21538461,11.4922997 0.376923072,11.5472868 0.484615384,11.5472868 Z M8.45384615,1.20971577 L10.0692308,2.85932817 L9.15384614,3.79410852 L7.53846153,2.14449612 L8.45384615,1.20971577 Z M1.02307692,8.8529199 L6.89230768,2.85932817 L8.50769229,4.50894058 L2.63846153,10.5025323 L1.02307692,10.5025323 L1.02307692,8.8529199 L1.02307692,8.8529199 Z" id="形状"></path>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>`
}} />

const icon3 = <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} dangerouslySetInnerHTML={{
    __html: `
<?xml version="1.0" encoding="UTF-8"?>
<svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>切片</title>
    <g id="小助手" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="未展开样式" transform="translate(-1138.000000, -15.000000)" fill="#11BBA6">
            <g id="编组-6备份-2" transform="translate(1128.000000, 10.000000)">
                <g id="加协作团队备份-11" transform="translate(10.000000, 5.000000)">
                    <g id="daoru-4" transform="translate(2.200000, 3.000000)">
                        <path d="M3.18494272,0 C2.83360611,0 2.55100927,0.282596836 2.55100927,0.633933442 L2.55100927,3.18494272 L3.81887616,3.18494272 L3.81887616,1.27550464 L13.3660666,1.27550464 L13.3660666,12.7321331 L3.81887616,12.7321331 L3.81887616,10.822695 L2.54337152,10.822695 L2.54337152,13.3660666 C2.54337152,13.7174032 2.82596836,14 3.17730496,14 L14,14 C14.3513366,14 14.6339334,13.7174032 14.6339334,13.3660666 L14.6339334,0.641571195 C14.6339334,0.290234588 14.3513366,0.00763775232 14,0.00763775232 C14,0 3.18494272,0 3.18494272,0 Z M6.04909984,4.7735952 C5.87343153,4.7735952 5.72831424,4.91871249 5.72831424,5.0943808 L5.72831424,6.36988543 L0.320785597,6.36988543 C0.145117294,6.36988543 0,6.51500273 0,6.69067103 L0,7.32460447 C0,7.50027278 0.145117294,7.64539007 0.320785597,7.64539007 L5.72831424,7.64539007 L5.72831424,8.91325696 L5.73595199,8.96672122 C5.74358974,9.03546099 5.78177851,9.08892526 5.82760502,9.13475177 C5.94980906,9.25695581 6.15602837,9.25695581 6.27823241,9.13475177 L8.18767049,7.22531369 L8.22585925,7.17948718 C8.30987452,7.04964539 8.29459902,6.88161484 8.18767049,6.77468631 L6.27823241,4.86524823 L6.24004364,4.82705947 C6.17894163,4.79650846 6.11020185,4.7735952 6.04909984,4.7735952 Z" id="形状"></path>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
`}} />

const icon5 = <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} dangerouslySetInnerHTML={{
    __html: `
<svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="面试问题页面流程优化" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="改简历" transform="translate(-758.000000, -16.000000)" fill="#4E5159" fill-rule="nonzero">
            <g id="编组-12" transform="translate(570.000000, 7.000000)">
                <g id="模块管理备份" transform="translate(188.000000, 9.000000)">
                    <g id="f-idea" transform="translate(3.613757, 1.687500)">
                        <path d="M7.18667506,13.3871582 L3.58806834,13.3871582 C3.24624001,13.3871582 2.96914746,13.6642508 2.96914746,14.0060791 C2.96914746,14.3479074 3.24624001,14.625 3.58806834,14.625 L7.18669179,14.625 C7.52852011,14.625 7.80561266,14.3479074 7.80561266,14.0060791 C7.80561266,13.6642508 7.52850339,13.3871582 7.18667506,13.3871582 Z M10.3511339,3.29016666 C10.0797454,2.6485799 9.69139767,2.07248165 9.19681298,1.57791369 C8.70226174,1.08334572 8.1261635,0.694981237 7.48457673,0.423609523 C6.82000626,0.142535806 6.11438627,0 5.3873717,0 C4.66035712,0 3.95473714,0.142535806 3.29016666,0.42362625 C2.6485799,0.694997964 2.07248165,1.08336245 1.57793042,1.57793042 C1.08336245,2.07249838 0.694997964,2.6485799 0.423609523,3.29018339 C0.142519078,3.95477059 0,4.66037385 0,5.38738843 C0,6.3238659 0.24417265,7.24645947 0.706121812,8.05543924 C1.09538959,8.73708859 1.63242891,9.32859294 2.27155672,9.78271359 L2.27155672,11.831509 C2.27155672,12.1733373 2.54864927,12.4504299 2.8904776,12.4504299 L7.88428253,12.4504299 C8.22611086,12.4504299 8.50320341,12.1733373 8.50320341,11.831509 L8.50320341,9.78271359 C9.14233121,9.32860967 9.67937053,8.73710531 10.0686383,8.05543924 C10.5305875,7.24645947 10.7747601,6.3238659 10.7747601,5.38738843 C10.7747601,4.66035712 10.6322243,3.95475387 10.3511339,3.29016666 Z M6.90075034,5.88369606 L5.47316751,7.99973636 C5.35361542,8.17694846 5.15832079,8.27258015 4.95951337,8.27258015 C4.83632105,8.27258015 4.71594478,8.23573327 4.61393806,8.166661 C4.33058939,7.97549808 4.25585051,7.59081366 4.44701342,7.30744827 L5.22352494,6.15647289 L4.38709519,6.15647289 C4.16259,6.15647677 3.95568614,6.0349061 3.84641743,5.83878642 C3.73714871,5.64266674 3.74265065,5.4027535 3.86079499,5.21184908 L5.04072582,3.30517131 C5.22061434,3.01451269 5.60207033,2.92470225 5.89272896,3.10457404 C6.18338759,3.28444583 6.27319802,3.66590182 6.09332623,3.95656045 L5.4979578,4.91861441 L6.38766493,4.91861441 C6.6165385,4.91860689 6.82673326,5.04490659 6.93417349,5.24699496 C7.04161371,5.44908333 7.02875871,5.69396739 6.90075034,5.88369606 L6.90075034,5.88369606 Z" id="形状"></path>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
`}} />

const icon4 = <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} dangerouslySetInnerHTML={{
    __html: `
<svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="面试问题页面流程优化" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="练面试-默认展示当前jd" transform="translate(-608.000000, -16.000000)" fill="#4E5159" fill-rule="nonzero">
            <g id="编组-12" transform="translate(570.000000, 7.000000)">
                <g id="模块管理" transform="translate(38.000000, 9.000000)">
                    <g id="01_neirongguanli" transform="translate(2.441250, 2.250000)">
                        <path d="M10.294964,6.99280576 L10.294964,13.1115108 C10.294964,13.4028777 10.1978417,13.5 9.90647482,13.5 L0.971223024,13.5 C0.291366912,13.5 0,13.1115108 0,12.528777 L0,0.971223007 C0,0.291366895 0.388489216,0 1.06834531,0 L9.32374101,0 C10.0035971,0 10.294964,0.291366912 10.294964,1.06834531 L10.294964,6.99280576 Z M8.6438849,3.30215826 C8.6438849,2.98032326 8.38298609,2.71942445 8.06115109,2.71942445 L2.33093526,2.71942445 C2.00910026,2.71942445 1.74820144,2.98032326 1.74820144,3.30215826 C1.74820144,3.62399326 2.00910026,3.88489208 2.33093526,3.88489208 L8.06115109,3.88489208 C8.38298609,3.88489208 8.6438849,3.62399326 8.6438849,3.30215826 Z M4.65741906,7.28417266 L6.79410971,7.28417266 C7.18259893,7.28417266 7.47396582,7.08992805 7.47396582,6.70143885 C7.47396582,6.31294963 7.18259891,6.11870504 6.79410971,6.11870504 L2.42360611,6.11870504 C2.0351169,6.11870504 1.74375,6.31294965 1.74375,6.70143885 C1.74375,7.08992806 2.03511691,7.28417266 2.42360611,7.28417266 L4.65741906,7.28417266 Z M4.65741906,10.6591727 L7.26423853,10.6591727 C7.65272774,10.6591727 7.94409464,10.464928 7.94409464,10.0764388 C7.94409464,9.68794963 7.65272773,9.49370504 7.26423853,9.49370504 L2.42360611,9.49370504 C2.0351169,9.49370504 1.74375,9.68794965 1.74375,10.0764388 C1.74375,10.4649281 2.03511691,10.6591727 2.42360611,10.6591727 L4.65741906,10.6591727 Z M11.4604317,8.06115107 L11.4604317,3.01079136 C11.4604317,2.6926954 11.7517986,2.5955731 12.3345324,2.71942445 C12.8201439,2.81654675 13.1115108,3.10791366 13.1115108,3.59352517 L13.1115108,12.528777 C13.1115108,13.0143885 12.7230216,13.4028777 12.2374101,13.4028777 C11.4604317,13.4028777 11.4604317,13.4028777 11.4604317,12.6258993 L11.4604317,8.06115107 Z" id="形状"></path>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
`}} />

const Title = () => {
    const titleVisible = useSelector((state) => !!state.resume);
    const resumeName = useSelector((state) => state.resume?.name);
    const resumeDate = useSelector((state) => state.resume?.updateDate);
    const dispatch = useDispatch();
    const [focus, setFocus] = useState(false);
    const onChange = useCallback(debounce((e) => {
        dispatch(resumeSlice.actions.changeName({ value: e.target.value }));
    }, 500), []);
    const date = useMemo(() => moment(resumeDate).format("YYYY-MM-DD"), [resumeDate])
    return <TitleBoxStyled style={{ visibility: titleVisible ? undefined : "hidden" }}>
        {
            !focus && <>
                <TitleStyled onClick={() => setFocus(true)}>{resumeName}-{date}</TitleStyled>
                <TitleIconStyled onClick={() => setFocus(true)}>{icon2}</TitleIconStyled>
            </>
        }
        {
            focus && <>
                <TitleInputStyled onChange={onChange} autoFocus defaultValue={resumeName}
                    onBlur={() => setFocus(false)} />
            </>
        }
    </TitleBoxStyled>
}

const HeaderContainerStyled = styled.div`
  height: 60px;
  background: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 50px;
  padding-left: 8px;
  flex-shrink: 0;
  position: relative;
  z-index: 3;
`

const TitleWrapStyled = styled.div`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    display: flex;
    align-items: center;

    .left,
    .right{
        width: 150px;
        height: 36px;
        background: #F4F6F7;
        color: #4E5159;
        font-size: 14px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        column-gap: 8px;
    }
    .left{
        border-radius: 32px 0 0 32px;
        &.active{
            color: #ffffff;
            background: linear-gradient( 270deg, #40D7AD 0%, #419EEE 100%);
            path {
                fill: #ffffff;
            }
        }
    }
    .right{
        border-radius: 0 32px 32px 0;
        &.active{
            color: #ffffff;
            background: linear-gradient( 270deg, #419EEE 0%, #40D7AD 100%);
            path {
                fill: #ffffff;
            }
        }
    }

    
`

const LineStyled = styled.div`
    width: 1px;
    height: 36px;
    background: #E5E5E5;
`


export default (props) => {
    const {
        store,
        onClickDown,
        resumeRef,
        setResumeLoading,
        setLoginVisible,
        tabKey,
        onChangeTab,
        setThemeVisible,
        setImportModalVisible,
        setChangeTemplateVisible,
        onClickModule
    } = props;
    const resumeData = useSelector(state => state.resumeData);


    const handleUploadVideo = async (file) => {
        const isLt50M = file.size / 1024 / 1024 < 50;
        if (!isLt50M) {
            message.error('单个简历文件最大为50m！');
            return false;
        }
        const requestId = v4()
        const formData = new FormData();
        formData.append('file', file);
        // formData.append('resumeBody', resumeData);
        try {
            setResumeLoading(true);
            await modifyResume({
                body: {
                    id: parseInt(getParam('id')),
                    requestId,
                    resumeBody: {
                        userData: resumeData
                    }
                }
            })
            const res = await uploadResumeAttachment({
                query: { requestId },
                body: formData
            })
            window.processModifyResume(res)
        } catch (error) {
            console.log('erroer', error)
        } finally {
            setResumeLoading(false)
        }
        return false;
    }

    return <HeaderContainerStyled>
        <FlexStyled $alignItems="center">
            {/* <LogoComponent isDark={false}/> */}
            <Back setLoginVisible={setLoginVisible} />
            <Title2 />
            <LineStyled />
            <Revocation isDark={true} resumeRef={resumeRef} style={{ margin: "0 10px" }} />
            <Recover isDark={true} resumeRef={resumeRef} />
            <SaveComponent setLoginVisible={setLoginVisible} style={{ marginRight: 16 }} />


        </FlexStyled>
        <TitleWrapStyled style={{ margin: "0 10px" }}>
            <div onClick={() => onChangeTab('resume')} className={`left ${tabKey === 'resume' && 'active'}`}>{icon4}改简历</div>
            <div onClick={() => onChangeTab('question')} className={`right ${tabKey === 'question' && 'active'}`}>{icon5}练面试</div>
        </TitleWrapStyled>
        <User />
        {/* <Menu 
            resumeRef={resumeRef} 
            setThemeVisible={setThemeVisible}
            setImportModalVisible={setImportModalVisible}
            setChangeTemplateVisible={setChangeTemplateVisible}
            onClickModule={onClickModule}/> */}
        {/* <ButtonStyled onClick={onClickDown}>
            <div>{icon}</div>
            下载
        </ButtonStyled> */}
        {/* <Upload
            // accept='video/*'
            beforeUpload={handleUploadVideo}
            showUploadList={false}
            multiple={false}
            className="custom-upload"
        >
            <Button2Styled>
                {icon3}
                导入简历
            </Button2Styled>
        </Upload> */}
        {/* <div /> */}


    </HeaderContainerStyled>
}
